// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__o_Y-7","productName":"Table_productName__1tw3y"};